import * as React from "react";
import {Box, HStack, VStack} from "@chakra-ui/react";
import {LoginPage} from "../login/LoginPage";
import {SignupPage} from "../signup/SignupPage";
import loginImage from "../../assets/images/login_new.png";
import loginImageSmartVenues from "../../assets/images/login.jpeg";
import signupImage from "../../assets/images/signup.jpeg";
import {AnimatedText, ChakraBox} from "../App";
import {useAppSelector} from "../../hooks/use-store";
import {IS_SMARTVENUES} from "../../utils/Utils";

function ImageLayer() {
    return <HStack gap={0} width={"100vw"} height={"100vh"} position={"absolute"}>
        <Box backgroundImage={IS_SMARTVENUES ? loginImageSmartVenues : loginImage} backgroundSize={"cover"} backgroundPosition={"center"} w={"50vw"}
             h={"100vh"}/>
        <Box backgroundImage={signupImage} backgroundSize={"cover"} backgroundPosition={"center"} w={"50vw"}
             h={"100vh"}/>
    </HStack>;
}

export default function LandingPage() {
    const {isSignup} = useAppSelector((state) => state.landing);

    // // // TODO: !!!! start
    // const oldBaseUrl = localStorage.getItem("baseurl") || "";
    //
    // const {data} = useQuery({
    //     queryKey: ['baseurl'],
    //     enabled: oldBaseUrl === "",
    //     queryFn: () => axios({
    //         url: "https://smartvenues-ee94d-default-rtdb.europe-west1.firebasedatabase.app/url.json",
    //         method: "GET"
    //     })
    // })
    //
    // const baseUrl = data?.data as string || "";
    // console.log(baseUrl);
    //
    // localStorage.setItem("baseurl", baseUrl);
    // // // TODO: !!!! end

    // @ts-ignore
    return (
        <Box w={"100vw"} h={"100vh"} backgroundColor={"surface.light"} overflow={"hidden"}>
            <ImageLayer/>

            <ChakraBox
                // @ts-ignore
                transition={{
                    duration: 1,
                    ease: "easeInOut"
                }}
                animate={{
                    marginLeft: isSignup ? 0 : "50vw",
                }}
                height={"100vh"}
                width={"50vw"}
                position={"absolute"}
                backgroundColor={"surface.light"}
            />

            <VStack
                w={"100%"}
                h={"100%"}
                position={"absolute"}>

                {IS_SMARTVENUES && <HStack w={"100%"} mt={"24px"} gap={8}>
                    <AnimatedText
                        // @ts-ignore
                        transition={{duration: 1, ease: "easeInOut"}}
                        animate={{color: !isSignup ? '#FFFFFF' : '#006c4b'}}
                        width={'50%'}
                        fontSize={'4vw'}
                        fontWeight={"bold"}
                        textAlign={'end'}>
                        SMART
                    </AnimatedText>
                    <AnimatedText
                        // @ts-ignore
                        transition={{duration: 1, ease: "easeInOut"}}
                        animate={{color: !isSignup ? '#006c4b' : '#3d6373'}}
                        width={'50%'}
                        fontSize={'4vw'}
                        fontWeight={"bold"}>
                        VENUES
                    </AnimatedText>
                </HStack>}

                <ChakraBox
                    // @ts-ignore
                    transition={{
                        duration: 1,
                        ease: "easeInOut"
                    }}
                    animate={{
                        marginLeft: isSignup ? 0 : "50vw"
                    }}
                    style={{
                        alignSelf: "start",
                        overflow: "auto",
                        width: "50vw",
                        marginTop: "auto",
                        marginBottom: "auto"
                    }}>

                    {!isSignup && <ChakraBox
                        // @ts-ignore
                        transition={{
                            duration: 1,
                            ease: "easeInOut"
                        }}
                        animation={{
                            opacity: !isSignup ? 0 : 1
                        }}
                    >
                        <LoginPage/>
                    </ChakraBox>}

                    {isSignup && <ChakraBox
                        // @ts-ignore
                        transition={{
                            duration: 1,
                            ease: "easeInOut"
                        }}
                        animation={{
                            opacity: isSignup ? 1 : 0
                        }}>
                        <SignupPage/>
                    </ChakraBox>}
                </ChakraBox>
            </VStack>
        </Box>
    )
}
